import * as React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
    Nav,
    NavList,
    NavItem,
    NavExpandable
} from '@patternfly/react-core';
import { IAppRoute, IAppRouteGroup, AppRouteConfig } from '@app/routes';
import UserAuthentication from '@app/Security/UserAuthentication';

interface NavigationProps {
    fpuRoutes: AppRouteConfig[]
}

const Navigation: React.FC<NavigationProps> = ({ fpuRoutes, children }) => {

    const location = useLocation();

    const logoutHandler = () => {

        console.log("logoutHandler");

        UserAuthentication.logout(true)
            .then((loggedOut: boolean) => {

                if (loggedOut) {
                    window.location.href = "/";
                } else {
                    console.log("something went wrong with the logout");
                }

            });

    };

    const renderNavItem = (route: IAppRoute, index: number) => {
        navItemCount++;
        const routeId = `page-${route.pageId}-${index}-${navItemCount}`;
        return (
            <NavItem key={routeId} id={routeId} isActive={route.path === location.pathname}>
                <NavLink exact to={{ pathname: route.path }}>
                    {route.label}
                </NavLink>
            </NavItem>
        )
    };

    const renderNavGroup = (group: IAppRouteGroup, groupIndex: number) => {
        navItemCount++;
        const groupId = `group-${groupIndex}-${navItemCount}`;
        return (
            <NavExpandable
                key={groupId}
                id={groupId}
                title={group.label}
                isActive={group.routes.some((route) => route.path === location.pathname)}
                isExpanded={location.pathname.startsWith(group.groupPath ?? "/error-path")}
            >
                {group.routes.map((route, idx) => route.label && ("path" in route ? renderNavItem(route, idx) : renderNavGroup(route, idx)))}
            </NavExpandable>
        )
    };

    let navItemCount = 0;

    return (
        <Nav id="nav-primary-simple" theme="dark">
            <NavList id="nav-list-simple">
                {fpuRoutes.map(
                    (route, idx) => route.label && ("path" in route ? renderNavItem(route, idx) : renderNavGroup(route, idx))
                )}
                <NavItem key="navitem-logout" id="navitem-logout-id" preventDefault onClick={logoutHandler}>
                    <NavLink exact to={'/'}>
                        Log Out
                    </NavLink>
                </NavItem>
            </NavList>
            <div>{children}</div>
        </Nav>
    );

};

export default Navigation;